module.exports = __webpack_public_path__ + "img/hp10.f8e7abcd.png";